import {Component} from "@angular/core";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DeviceService} from "../../device/device.service";
import {SiteDesignService} from "../../site-design/site-design.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {toggleLoading} from "../../misc/loading.decorator";
import {bulkOrderCountModelListFactory} from "./bulk-order-count.model";
import {AddAssetDialogComponent} from "./add-assets-dialog.component";
import {Observable} from "rxjs";
import {dartPurchaseOption} from "../../types/simplify-constants";
import {AppSettingsService} from "../../app-settings/app-settings.service";

interface DeviceModel {
  projectId: string;
  targetId: string;
  assetType: string;
}

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

@Component({
  templateUrl: "./add-individual-assets-dialog.template.pug",
  providers: [
    DeviceService,
    SiteDesignService,
  ],
})
export class AddIndividualAssetsDialogComponent extends DialogComponent<DeviceModel, number> {
  projectId: string;
  targetId: string;
  devices: any[] = [];
  currentPage: number = DEFAULT_PAGE;
  pageSize: number = DEFAULT_PAGE_LIMIT;
  maxPages: number;
  totalCount: number = 0;
  searchText: string = "";
  error: Error;
  loading: boolean = false;
  assetType: string;
  assetTypes: any = {
    asset: "Devices",
    accessory: "Accessories",
    software: "Software",
  };
  POR606TMC: boolean;

  static showAddIndividualAssetModal(
    dialogService: DialogService,
    model: DeviceModel,
  ): Observable<number> {
    return dialogService.addDialog(AddIndividualAssetsDialogComponent, model, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  constructor(
    public dialogService: DialogService,
    private deviceService: DeviceService,
    private siteDesignService: SiteDesignService,
    private appSettingsService: AppSettingsService,
  ) {
    super(dialogService);
  }
  
  ready(): any {
    this.loadData();
  }

  @toggleLoading()
  @handleErrors()
  async loadData(): Promise<any> {
    if (!this.projectId) return;

    const {rows, count} = await this.siteDesignService.getDevicesForSiteDesign(
      `${+(this.currentPage) - 1}`,
      `${+(this.pageSize)}`,
      this.searchText,
      this.projectId,
      this.targetId,
      this.assetType,
    );

    this.devices = rows;
    this.maxPages = Math.ceil(count / (+this.pageSize));
    this.totalCount = count;
  }

  onListControlsChange(event) {
    switch (event["key"]) {
      case "page":
        this.currentPage = event["value"];
        break;
      case "search":
        this.currentPage = DEFAULT_PAGE;
        this.searchText = event["value"];
        break;
      case "limit":
        this.currentPage = DEFAULT_PAGE;
        this.pageSize = event["value"];
        break;
      default:
        console.info(`Unknown ${event["key"]}`);
        break;
    }

    if (!this.projectId) return;

    this.loadData();
  }

  add({
    id, bulkOrderCounts, quantityAvailable, enableCatalogPricing, productDescription, productNumber, quantityAssigned,
    acquisitionMethod,
  }): void {
    const defaultValues = {};
    const dialogInput = {
      siteId: this.targetId,
      deviceId: id,
      maxQuantity: enableCatalogPricing ? Number.MAX_SAFE_INTEGER : quantityAvailable,
      bulkOrderCounts: bulkOrderCountModelListFactory(bulkOrderCounts).filter(it => it.available > 0),
      defaultValues,
      deviceType: this.assetType,
      productDescription,
      productNumber,
      softwareQuantity: enableCatalogPricing ? Number.MAX_SAFE_INTEGER : quantityAvailable - quantityAssigned,
      acquisitionMethod: acquisitionMethod && acquisitionMethod.length > 0 ?
        dartPurchaseOption[acquisitionMethod[0]] : "",
    };

    AddAssetDialogComponent.showAssetModal(this.dialogService, dialogInput)
      .subscribe(() => {
        this.loadData();
      });
  }
 async ngOnInit() {
    this.POR606TMC  = await this.appSettingsService.getFeaturePermission("POR606_TMC");
  }
}
